<template>
  <div
    class="
     vs-empty-state
      d-flex justify-content-center align-item-center flex-column text-center
    "
  >
    <div class="vs-empty-state__icon w-100">
      <VsIcon
        v-if="icon"
        :icon="icon"
      />
      <img
        v-else-if="name"
        :src="`/images/empty-states/${name}.svg`"
      >
      <img
        v-else-if="src"
        :src="src"
      >
    </div>
    <div class="vs-empty-state__text">
      <h3 v-if="title">
        {{ title }}
      </h3>
      <p v-if="message">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
import VsIcon from '@/scripts/Components/Molecules/VsIcon';

export default {
  components: {
    VsIcon,
  },
  props: {
    // Empty state icon
    icon: {
      type: String,
      default: undefined,
    },
    name: {
      type: String,
      default: undefined,
    },
    src: {
      type: String,
      default: undefined,
    },

    // Text
    title: {
      type: String,
      default: undefined,
    },
    message: {
      type: String,
      default: undefined,
    },
  },
};
</script>

<style lang="scss" scoped>
.vs-empty-state {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
}

.vs-empty-state__icon {
  font-size: 180px;
  line-height: 1;
  max-width: 240px;
  margin-left: auto;
  margin-right: auto;

  > .vs-icon {
    color: rgba(0,0,0,0.4);
  }

  > img {
    width: 100%;
    height: 100%;
  }
}

.vs-empty-state__text {
  margin-top: 1em;
  font-size: 1em;
  color: rgba(black, 0.6);

  > h3 {
    margin: 0 auto;
    line-height: 1.4;
  }

  > h3 + p {
    margin: 0.8em auto;
    margin-bottom: 0;
    line-height: 1.5;
    max-width: 320px;
  }
}
</style>
